import getRequestConfig from "./ApiEndPoints";
import HttpClient from "./Client";

export default async function executeRequest<T>(
  RequestType: string,
  data: any = [],
  params?: Record<string, string>
) {
  const endPointConfig = getRequestConfig(RequestType);

  const webClient = new HttpClient(process.env.REACT_APP_API_URI ?? "/api");
  const url = getUrl(endPointConfig.url, params);

  let response;

  switch (endPointConfig.method) {
    case "GET":
      response = webClient.get<T>(url, RequestType, data);
      break;
    case "POST":
      response = webClient.post<T>(url, RequestType, data);
      break;
    case "PUT":
      response = webClient.put<T>(url, RequestType, data);
      break;
    case "DELETE":
      response = webClient.delete<T>(url, RequestType);
      break;

    default:
      throw new Error("method not implemented");
  }

  return response;
}

function getUrl(url: string, params?: Record<string, string>) {
  let resultUrl = url;
  if (params) {
    for (var key in params) {
      resultUrl = resultUrl.replace("/:" + key + "/", "/" + params[key] + "/");
      if (resultUrl.endsWith("/:" + key)) {
        resultUrl = resultUrl.replace("/:" + key, "/" + params[key]);
      }
    }
  }
  return resultUrl;
}

export function getApiUrl(
  requestType: string,
  params?: Record<string, string>
) {
  const endPointConfig = getRequestConfig(requestType);
  return (
    (process.env.REACT_APP_API_URI ?? "/api") +
    getUrl(endPointConfig.url, params)
  );
}
